// extracted by mini-css-extract-plugin
module.exports = {"root":"SockyRotate_root__1nB08","icon":"SockyRotate_icon__XfFrw","text":"SockyRotate_text__1adZM"};